import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CookieBanner from '../../components/feature/CookieBanner';

export default function Kvkk() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="pt-32 pb-20">
        <div className="max-w-[900px] mx-auto px-6">
          <article className="prose prose-lg max-w-none">
            <header className="mb-12">
              <h1 className="text-5xl font-bold text-primary mb-4">KVKK Aydınlatma Metni</h1>
              <p className="text-gray-600">Son Güncelleme: 01 Ocak 2026</p>
            </header>

            <section className="mb-10">
              <h2 className="text-3xl font-bold text-primary mb-4">1. Veri Sorumlusu</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, kişisel verileriniz; veri sorumlusu olarak <strong>Bursa Tente</strong> (3168 Sokak No:14, Bursa) tarafından aşağıda açıklanan kapsamda işlenebilecektir.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-3xl font-bold text-primary mb-4">2. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebebi</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Kişisel verileriniz, <strong>Bursa Tente</strong> tarafından sunulan hizmetlerden yararlanmanız nedeniyle;
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                <li>Web sitemiz üzerinden</li>
                <li>Telefon ve WhatsApp iletişim kanalları üzerinden</li>
                <li>E-posta yoluyla</li>
                <li>Keşif ve montaj süreçlerinde</li>
              </ul>
              <p className="text-gray-700 leading-relaxed">
                tamamen veya kısmen otomatik yollarla toplanmaktadır.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-3xl font-bold text-primary mb-4">3. İşlenen Kişisel Veriler</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Hizmetlerimizden faydalanmanız kapsamında aşağıdaki kişisel verileriniz işlenmektedir:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li><strong>Kimlik Bilgileri:</strong> Ad, soyad</li>
                <li><strong>İletişim Bilgileri:</strong> Telefon numarası, e-posta adresi, adres bilgileri</li>
                <li><strong>Müşteri İşlem Bilgileri:</strong> Teklif talepleri, siparişler, montaj bilgileri</li>
                <li><strong>İşlem Güvenliği Bilgileri:</strong> IP adresi, çerez kayıtları</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-3xl font-bold text-primary mb-4">4. Kişisel Verilerin İşlenme Amaçları</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Toplanan kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Tente ve pergola ürün ve hizmetlerinin sunulması</li>
                <li>Teklif hazırlanması ve müşteri taleplerine yanıt verilmesi</li>
                <li>Keşif, ölçüm ve montaj hizmetlerinin gerçekleştirilmesi</li>
                <li>Müşteri memnuniyetinin sağlanması ve iletişim faaliyetlerinin yürütülmesi</li>
                <li>Yasal yükümlülüklerin yerine getirilmesi</li>
                <li>Ticari faaliyetlerin planlanması ve yürütülmesi</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-3xl font-bold text-primary mb-4">5. Kişisel Verilerin Aktarılması</h2>
              <p className="text-gray-700 leading-relaxed">
                Toplanan kişisel verileriniz, KVKK'nın 8. ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları çerçevesinde, iş ortaklarımıza, tedarikçilerimize, hukuki yükümlülüklerimizi yerine getirmek amacıyla kanunen yetkili kamu kurumları ve özel kişilere aktarılabilecektir.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-3xl font-bold text-primary mb-4">6. Kişisel Veri Sahibinin Hakları</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                KVKK'nın 11. maddesi uyarınca, kişisel veri sahipleri olarak aşağıdaki haklara sahipsiniz:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
                <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme</li>
                <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme</li>
                <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerinizin silinmesini veya yok edilmesini isteme</li>
                <li>Kişisel verilerinizin düzeltilmesi, silinmesi veya yok edilmesine ilişkin işlemlerin aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
                <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>
                <li>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-3xl font-bold text-primary mb-4">7. İletişim</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Kişisel verileriniz ile ilgili taleplerinizi aşağıdaki iletişim kanalları üzerinden bize iletebilirsiniz:
              </p>
              <div className="bg-gray-50 rounded-xl p-6">
                <p className="text-gray-700 mb-2"><strong>Adres:</strong> 3168 Sokak No:14, Bursa</p>
                <p className="text-gray-700 mb-2"><strong>Telefon:</strong> +90 542 182 19 25</p>
                <p className="text-gray-700"><strong>Web:</strong> bursatente.com.tr</p>
              </div>
            </section>
          </article>
        </div>
      </main>

      <Footer />
      <CookieBanner />
    </div>
  );
}